<template>
  <v-btn
    text small height="32" class="action-btn elevation-0 rounded-lg pa-0"
    @click="$router.push(location)"
  >
    <v-icon class="uikit-icon size-20" :class="icon" />
    <span class="ml-1 btn-text text-start" v-html="title" />
  </v-btn>
</template>

<script>
export default {
  name: 'ButtonGoTo',

  props: {
    location: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Вернуться',
    },
    icon: {
      type: String,
      default: 'chevron-left',
    },
  },
}
</script>
